/* ============================================================
   きもの永見 商品詳細ページ用 スティッキー購入バー
   ファイル: assets/sticky-buy-bar.js

   機能:
   - 5状態の管理（ready / needs-selection / loading / soldout / error）
   - バリエーション選択UIとの連動
   - カート追加（fetch /cart/add.js）
   - Shopify標準ドロワーの自動オープン
   - 警告・エラー時のトースト表示
   - GA4イベント送信
   - 【NEW】PC上部追従：本来CTAが画面外で表示・画面内で非表示
   ============================================================ */

(function () {
  'use strict';

  var bar = document.querySelector('[data-kn-buy-bar]');
  if (!bar) return;

  var cta = bar.querySelector('[data-kn-cta]');
  var ctaLabel = bar.querySelector('[data-kn-cta-label]');
  var ctaIcon = bar.querySelector('[data-kn-cta-icon]');
  var lineBtn = bar.querySelector('[data-kn-line-btn]');
  var priceEl = bar.querySelector('[data-kn-price]');
  var toast = document.querySelector('[data-kn-toast]');
  var hasVariants = bar.getAttribute('data-has-variants') === 'true';
  var lineUrl = bar.getAttribute('data-line-url');
  var productId = bar.getAttribute('data-product-id');
  var productHandle = bar.getAttribute('data-product-handle');

  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var isPC = function () { return window.matchMedia('(min-width: 750px)').matches; };

  // ============================================================
  // SVGアイコン
  // ============================================================
  var ICONS = {
    cart: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    chevron: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',
    spinner: '<svg class="kn-spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>',
    info: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
    error: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
  };

  // ============================================================
  // 状態管理
  // ============================================================
  var STATES = {
    READY: 'ready',
    NEEDS_SELECTION: 'needs-selection',
    LOADING: 'loading',
    SOLDOUT: 'soldout'
  };

  // 現在選択中のバリエーション名（複数オプションは「・」で連結）
  var currentVariantTitle = '';

  function setState(state) {
    bar.setAttribute('data-state', state);
    switch (state) {
      case STATES.READY:
        cta.disabled = false;
        // バリエーション名がある場合は「黒地 · カートに追加」のように表示
        if (currentVariantTitle) {
          ctaLabel.textContent = currentVariantTitle + ' · カートに追加';
        } else {
          ctaLabel.textContent = 'カートに追加';
        }
        ctaIcon.innerHTML = ICONS.cart;
        break;
      case STATES.NEEDS_SELECTION:
        cta.disabled = false;
        ctaLabel.textContent = 'サイズを選択';
        ctaIcon.innerHTML = ICONS.chevron;
        break;
      case STATES.LOADING:
        cta.disabled = true;
        ctaLabel.textContent = '追加中…';
        ctaIcon.innerHTML = ICONS.spinner;
        break;
      case STATES.SOLDOUT:
        cta.disabled = true;
        break;
    }
  }

  // ============================================================
  // バリエーション選択UI検出
  // ============================================================
  function findVariantSelector() {
    var selectors = [
      'form[action*="/cart/add"] [name="id"]',
      'product-form [name="id"]',
      '[data-product-form] [name="id"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getCurrentVariantId() {
    var selector = findVariantSelector();
    if (!selector) return null;
    var value = selector.value;
    return value && value !== '' ? value : null;
  }

  // ============================================================
  // バリエーション変更監視
  // ============================================================
  var productData = null;

  function loadProductData() {
    if (productData) return Promise.resolve(productData);
    return fetch('/products/' + productHandle + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productData = data;
        return data;
      })
      .catch(function () { return null; });
  }

  function formatPrice(cents) {
    var yen = Math.round(cents / 100);
    return '¥' + yen.toLocaleString('ja-JP');
  }

  function onVariantChange() {
    var variantId = getCurrentVariantId();
    if (!variantId) {
      currentVariantTitle = '';
      setState(STATES.NEEDS_SELECTION);
      return;
    }
    loadProductData().then(function (product) {
      if (!product) {
        currentVariantTitle = '';
        setState(STATES.READY);
        return;
      }
      var variant = product.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) {
        currentVariantTitle = '';
        setState(STATES.READY);
        return;
      }

      // バリエーション名を取得
      // variant.options は配列（例: ["黒地"], ["M", "赤"]）
      // 複数オプションの場合は "・" で連結
      if (variant.options && variant.options.length > 0) {
        currentVariantTitle = variant.options.filter(function (o) {
          return o && o.toLowerCase() !== 'default title';
        }).join(' · ');
      } else if (variant.title && variant.title.toLowerCase() !== 'default title') {
        currentVariantTitle = variant.title;
      } else {
        currentVariantTitle = '';
      }

      if (priceEl && variant.price != null) {
        priceEl.textContent = formatPrice(variant.price);
      }
      if (variant.available === false) {
        setState(STATES.SOLDOUT);
      } else {
        setState(STATES.READY);
      }
    });
  }

  function watchVariants() {
    var selector = findVariantSelector();
    if (!selector) return;
    selector.addEventListener('change', onVariantChange);
    var form = selector.closest('form');
    if (form) {
      form.addEventListener('change', function () {
        setTimeout(onVariantChange, 50);
      });
    }
  }

  // ============================================================
  // 初期状態
  // ============================================================
  function initState() {
    var soldout = bar.getAttribute('data-state') === STATES.SOLDOUT;
    if (soldout) {
      setState(STATES.SOLDOUT);
      return;
    }
    if (hasVariants && !getCurrentVariantId()) {
      setState(STATES.NEEDS_SELECTION);
      return;
    }
    // バリエーションがある商品では、初期選択中のバリエーション名を取得して表示
    if (hasVariants) {
      onVariantChange();
    } else {
      setState(STATES.READY);
    }
  }

  // ============================================================
  // CTAタップ処理
  // ============================================================
  cta.addEventListener('click', function (e) {
    e.preventDefault();
    var state = bar.getAttribute('data-state');

    if (state === STATES.NEEDS_SELECTION) {
      var selector = findVariantSelector();
      if (selector) {
        var target = selector.closest('fieldset, .product-form__input, [class*="variant"], product-form') || selector;
        if (target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      showToast('サイズを選択してください', 'info');
      return;
    }

    if (state === STATES.LOADING || cta.disabled) return;

    if (state === STATES.READY) {
      addToCart();
    }
  });

  // ============================================================
  // 在庫切れ時のLINE
  // ============================================================
  if (lineBtn) {
    lineBtn.addEventListener('click', function (e) {
      e.preventDefault();
      sendGAEvent('sticky_buy_bar_line_inquiry', {
        product_id: productId,
        product_handle: productHandle,
        reason: 'soldout'
      });
      window.open(lineUrl, '_blank', 'noopener');
    });
  }

  // ============================================================
  // カート追加
  // ============================================================
  function addToCart() {
    var variantId = getCurrentVariantId();
    if (!variantId) {
      showToast('商品が選択されていません', 'error');
      return;
    }

    setState(STATES.LOADING);

    var form = document.querySelector('form[action*="/cart/add"]');
    var formData;
    if (form) {
      formData = new FormData(form);
    } else {
      formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
    }
    if (!formData.has('id')) {
      formData.append('id', variantId);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error(err && err.description ? err.description : 'カート追加に失敗しました');
          });
        }
        return r.json();
      })
      .then(function (item) {
        sendGAEvent('add_to_cart', {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JPY',
          value: (item.price || 0) / 100,
          items: [{
            item_id: productId,
            item_name: item.product_title || (item.product && item.product.title) || '',
            item_variant: item.variant_title || '',
            quantity: item.quantity || 1,
            price: (item.price || 0) / 100
          }]
        });
        sendGAEvent('sticky_buy_bar_add', {
          product_id: productId,
          product_handle: productHandle,
          variant_id: variantId,
          device: isMobile() ? 'mobile' : 'desktop'
        });

        triggerCartDrawer();

        setTimeout(function () { initState(); }, 800);
      })
      .catch(function (err) {
        var msg = err && err.message ? err.message : 'カート追加に失敗しました。少し時間を置いてお試しください。';
        showToast(msg, 'error');
        setTimeout(function () { initState(); }, 300);
      });
  }

  // ============================================================
  // Shopifyドロワーオープン
  // ============================================================
  function triggerCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('on:cart:after-add'));
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }

    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') { notification.open(); return; }

    var drawerEl = document.querySelector('.cart-drawer, #CartDrawer, .drawer--cart, #sidebar-cart');
    if (drawerEl) {
      drawerEl.classList.add('active', 'is-open', 'is-active', 'animate', 'drawer--is-open');
      document.documentElement.classList.add('cart-drawer-open', 'overflow-hidden');
      document.body.classList.add('cart-drawer-open', 'js-drawer-open', 'js-drawer-open-cart');
    }
  }

  // ============================================================
  // トースト
  // ============================================================
  var toastTimer = null;
  function showToast(text, type) {
    if (!toast) return;
    var toastText = toast.querySelector('[data-kn-toast-text]');
    var toastIcon = toast.querySelector('[data-kn-toast-icon]');
    if (toastText) toastText.textContent = text;
    if (toastIcon) toastIcon.innerHTML = type === 'error' ? ICONS.error : ICONS.info;
    toast.setAttribute('data-type', type || 'info');
    toast.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.setAttribute('data-show', 'true');
      });
    });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.setAttribute('data-show', 'false');
      setTimeout(function () { toast.setAttribute('hidden', ''); }, 350);
    }, 3000);
  }

  // ============================================================
  // GA4
  // ============================================================
  function sendGAEvent(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params || {});
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var pushData = { event: eventName };
      for (var key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          pushData[key] = params[key];
        }
      }
      window.dataLayer.push(pushData);
    }
  }

  // ============================================================
  // PC上部追従ロジック
  // 本来の「カートに追加」ボタンが画面外なら表示、画面内なら非表示
  // ============================================================
  function findOriginalCTA() {
    // 本来の購入ボタンを探す（複数候補を試行、フッター内のは除外）
    var candidates = [
      'form[action*="/cart/add"] button[name="add"]',
      'form[action*="/cart/add"] [type="submit"]',
      'product-form button[name="add"]',
      'product-form [type="submit"]',
      '.product-form__submit',
      '.product__submit-button',
      '.btn--add-to-cart',
      '.product-single__cart-submit',
      'button.add-to-cart',
      '#add-to-cart',
      '#AddToCart'
    ];

    for (var i = 0; i < candidates.length; i++) {
      var els = document.querySelectorAll(candidates[i]);
      for (var j = 0; j < els.length; j++) {
        // バー自身やフッター内のボタンは除外
        if (bar.contains(els[j])) continue;
        var rect = els[j].getBoundingClientRect();
        // 表示されているボタンのみ
        if (rect.width > 0 && rect.height > 0) {
          return els[j];
        }
      }
    }
    return null;
  }

  function setupPCStickyVisibility() {
    if (!isPC()) return;

    var originalCTA = findOriginalCTA();

    // 本来のCTAが見つからない場合：スクロール量で代用（300pxスクロールで表示）
    if (!originalCTA) {
      var scrollHandler = function () {
        if (!isPC()) {
          bar.removeAttribute('data-visible');
          return;
        }
        if (window.scrollY > 300) {
          bar.setAttribute('data-visible', 'true');
        } else {
          bar.removeAttribute('data-visible');
        }
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
      scrollHandler();
      return;
    }

    // IntersectionObserverで本来CTAの表示状態を監視
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!isPC()) {
          bar.removeAttribute('data-visible');
          return;
        }
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 本来CTAが画面内 → スティッキーバー非表示
            bar.removeAttribute('data-visible');
          } else {
            // 本来CTAが画面外 → スティッキーバー表示
            // ただしページ最上部付近では非表示にする（スクロールしてないのに出ないように）
            if (window.scrollY > 100) {
              bar.setAttribute('data-visible', 'true');
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '-20px 0px 0px 0px'
      });
      observer.observe(originalCTA);
    } else {
      // IntersectionObserver非対応：スクロール量で代用
      var fallbackHandler = function () {
        if (!isPC()) {
          bar.removeAttribute('data-visible');
          return;
        }
        var rect = originalCTA.getBoundingClientRect();
        if (rect.bottom < 0) {
          bar.setAttribute('data-visible', 'true');
        } else {
          bar.removeAttribute('data-visible');
        }
      };
      window.addEventListener('scroll', fallbackHandler, { passive: true });
      fallbackHandler();
    }
  }

  // ウィンドウリサイズでモバイル/PC切替に対応
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (isMobile()) {
        // モバイルでは常に表示なのでdata-visibleは不要
        bar.removeAttribute('data-visible');
      }
    }, 200);
  });

  // ============================================================
  // 他コンポーネントのカート操作監視
  // ============================================================
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var urlArg = args[0];
      var url = '';
      if (typeof urlArg === 'string') url = urlArg;
      else if (urlArg && urlArg.url) url = urlArg.url;
      var promise = origFetch.apply(this, args);
      if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        promise.then(function () { setTimeout(onVariantChange, 200); }).catch(function () {});
      }
      return promise;
    };
  }

  // ============================================================
  // 初期化
  // ============================================================
  initState();
  watchVariants();

  // PC追従はDOMが安定してから設定
  if (document.readyState === 'complete') {
    setupPCStickyVisibility();
    setupFloatingButtonSticky();
  } else {
    window.addEventListener('load', function () {
      setupPCStickyVisibility();
      setupFloatingButtonSticky();
    });
  }

  // ============================================================
  // LINE相談ボタン（floating-button）を強制的にbody直下に移動して追随
  // テーマの親要素position制限が強い場合のJS強制対策
  // ============================================================
  function setupFloatingButtonSticky() {
    var floatingBtn = document.querySelector('.floating-button');
    if (!floatingBtn) return;

    // モバイルではLINEボタンを完全に隠す（CSSと併用、インラインstyleもクリア）
    if (isMobile()) {
      // 過去にJSが付与したインラインstyleがdisplay:noneを邪魔しないようにクリア
      floatingBtn.style.cssText = '';
      // CSSの display: none !important が確実に効くように
      return;
    }

    // 既にbody直下にあるかチェック
    if (floatingBtn.parentElement !== document.body) {
      // body直下に移動（親要素のposition制限から解放）
      document.body.appendChild(floatingBtn);
    }

    // 商品ページかどうかを判定
    function isProductPage() {
      return !!document.querySelector('.kn-buy-bar') ||
             /template-product/.test(document.body.className) ||
             /\/products\//.test(window.location.pathname);
    }

    // インラインstyleで強制配置（CSSの優先度に頼らない）
    function applyPosition() {
      var bottomValue;
      if (isPC()) {
        bottomValue = '28px';
      } else if (isProductPage()) {
        // 商品ページ: 購入バー64px + グローバルフッター60px + LINE高46px + 余白25px
        bottomValue = 'calc(195px + env(safe-area-inset-bottom, 0))';
      } else {
        // 通常ページ: グローバルフッター60px + 余白20px
        bottomValue = 'calc(80px + env(safe-area-inset-bottom, 0))';
      }

      floatingBtn.style.cssText += ';' + [
        'position: fixed',
        'top: auto',
        'left: auto',
        'right: ' + (isPC() ? '28px' : '14px'),
        'bottom: ' + bottomValue,
        'z-index: 98',
        'transform: none',
        'margin: 0',
        'padding: 0',
        'width: auto',
        'max-width: none'
      ].map(function (s) { return s + ' !important'; }).join('; ');
    }

    applyPosition();

    // リサイズ時に位置を再計算
    window.addEventListener('resize', function () {
      applyPosition();
    });

    // テーマのスクリプトが後からpositionを上書きしないように、
    // MutationObserverで style 属性の変更を監視して再適用
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'style') {
            var currentPos = window.getComputedStyle(floatingBtn).position;
            var currentBottom = window.getComputedStyle(floatingBtn).bottom;
            // positionがfixedでない、または bottomが期待値と違う場合は再適用
            if (currentPos !== 'fixed') {
              applyPosition();
            }
          }
        });
      });
      observer.observe(floatingBtn, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

})();